module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaRisco,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5047367e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/riscos/index.vue
// module id = 1477
// module chunks = 45